import React, { useEffect, useState } from 'react';
import { FileBrowser } from '../../../../components/storage';
import { useIioListing, type ForensicImageType } from '../hooks/useIioListing';

interface Props {
  projectId: string;
  selectedPath: string | null;
  onPathChange: (path: string) => void;
  forensicImageType?: ForensicImageType | null;
  disabled: boolean;
  // Forensic Image reuses this listing with a different title, path prefix, and no level-up.
  title?: string;
  forensic?: boolean;
}

// IIO auto-loads on mount and refetches on directory navigation. Single-click selects a
// row; double-click opens a directory; the level-up button walks up one path segment.
export function IioSource({
  projectId,
  selectedPath,
  onPathChange,
  forensicImageType,
  disabled,
  title = 'IIO Drive Listing',
  forensic = false,
}: Props) {
  const [baseDir, setBaseDir] = useState('');
  const { data, isFetching, refetch } = useIioListing(projectId, baseDir, true, forensicImageType);

  useEffect(() => { refetch(); }, [baseDir]);

  const type = data?.type ?? '';
  const files = data?.files ?? [];

  const pathLabel = forensic ? `${type} / mobile-data / ${baseDir}` : `${type} /${baseDir}`;

  const levelUp = () => {
    const parts = baseDir.split('/').filter(Boolean);
    parts.pop();
    setBaseDir(parts.join('/'));
  };

  const uploadsMessage = (
    <div>
      <strong>Wondering what's supposed to be here?</strong> When you created your project we emailed you a
      summary of your Project details. Included in that email was the login information for your Project's
      SFTP server. Once you upload, you can create a collection here from one of the first level of files
      from your uploads folder.
    </div>
  );

  return (
    <div>
      <h4>
        <button
          type="button"
          className="btn btn-default btn-xs"
          onClick={() => refetch()}
          disabled={isFetching || disabled}
        >
          <i className={`fas ${isFetching ? 'fa-spinner fa-spin' : 'fa-sync-alt'}`} aria-hidden="true" />
        </button>{' '}
        {title}
      </h4>
      <FileBrowser
        pathLabel={pathLabel}
        files={files}
        loading={isFetching}
        selectedPath={selectedPath}
        onSelect={onPathChange}
        onNavigate={setBaseDir}
        onLevelUp={forensic ? undefined : levelUp}
        showEmptyAlert
        emptyMessage={type === 'uploads' ? uploadsMessage : undefined}
      />
    </div>
  );
}
